(function () {
  'use strict';

  var $ = window.jQuery;
  var Waypoint = window.Waypoint;

  function ArticleInfinite(options) {
    if (!options) {
      throw new Error('No options passed to ArticleInfinite constructor');
    }
    if (!options.url) {
      throw new Error('No URL passed to ArticleInfinite constructor');
    }
    if (!options.element) {
      throw new Error('No element passed to ArticleInfinite constructor');
    }
    this.options = $.extend({}, ArticleInfinite.defaults, options);
    this.container = this.options.element;
    if (this.options.container !== 'auto') {
      this.container = this.options.container;
    }
    this.$container = $(this.container);
    this.$url = this.options.url;

    if (this.$url) {
      this.setupHandler();
      this.waypoint = new Waypoint(this.options);
    }

  }

  /* Private */
  ArticleInfinite.prototype.setupHandler = function () {
    var $self = this;
    this.options.handler = function () {
      $self.options.onBeforePageLoad();
      $self.destroy();
      $self.$container.addClass($self.options.loadingClass);

      if ($('html').hasClass('wmt-mobile-app-detected') && $self.options.disableOnMobile === true) {
        return;
      }

      $.ajax({
        url: $self.$url,
        data: $self.options.queryOptions,
        dataType: 'json',
        success: function (data) {
          if (data.length) {
            $.each(data, function (k, v) {
              $self.$container.append(v);
            });

            $self.options.queryOptions.offset = $self.$container.find($self.options.items).length;

            $self.waypoint = new Waypoint($self.options);
            $self.setupChangeUrlSpy();
          }
          $self.$container.removeClass($self.options.loadingClass);

          $self.options.onAfterPageLoad(data);

          var sidebarLeft = $('.sidebar-wrap');
          if (sidebarLeft.length) {
            sidebarLeft.trigger("sticky_kit:recalc");
          }

          var $shareSelector = $('.article-share');
          if ($shareSelector.length) {
            $shareSelector.stick_in_parent({
              offset_top: 110,
              sticky_class: 'is_stuck',
              recalc_every: 1,
              inner_scrolling: true,
              parent: '.article_wrapper'
            });
          }
        }
      });
    };
  };

  ArticleInfinite.prototype.setupChangeUrlSpy = function () {
    console.log('setupChangeUrlSpy');

    var $self = this,
      $elements = $('[data-init="article-spy"]');

    if (this.$topWaypoints) {
      $.each(this.$topWaypoints, function (k, waypointElement) {
        waypointElement.destroy();
      });
    }

    if (this.$bottomWaypoints) {
      $.each(this.$bottomWaypoints, function (k, waypointElement) {
        waypointElement.destroy();
      });
    }

    this.$topWaypoints = $elements.waypoint(function (direction) {
      if (direction === 'down') {
        $self.changeUrl(this.element);
      }
    }, {
      offset: 0
    });

    this.$bottomWaypoints = $elements.waypoint(function (direction) {
      if (direction === 'up') {
        $self.changeUrl(this.element);
      }
    }, {
      offset: function () {
        return -this.element.clientHeight;
      }
    });
  };

  ArticleInfinite.prototype.changeUrl = function (element) {
    var url = $(element).data('permalink'),
      title = $(element).data('post-title');

    if (!(window.history && history.pushState)) {
      console.error('[articleInfiniteScroll] History does not support');
      return;
    }

    document.title = title;
    history.pushState(null, title, url);

    firePageView();
  };

  /* Public */
  ArticleInfinite.prototype.destroy = function () {
    if (this.waypoint) {
      this.waypoint.destroy();
    }
  };

  ArticleInfinite.defaults = {
    container: 'auto',
    items: '.infinite-item',
    offset: function () {
      var documentHeight = this.context.innerHeight(),
        elementHeight = this.adapter.outerHeight();
      return documentHeight - elementHeight + (elementHeight / 4);
    },
    queryOptions: {},
    loadingClass: 'infinite-loading',
    onBeforePageLoad: $.noop,
    onAfterPageLoad: $.noop,
    disableOnMobile: false,
  };

  Waypoint.ArticleInfinite = ArticleInfinite;
}());
